export default __webpack_public_path__ + "static/media/gallery-img.e2d07486.png";